import { render, staticRenderFns } from "./WebsitePageOverview.vue?vue&type=template&id=06c97b7c&scoped=true&"
import script from "./WebsitePageOverview.vue?vue&type=script&lang=js&"
export * from "./WebsitePageOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c97b7c",
  null
  
)

export default component.exports